import { type SuretyEntityIdMap } from "../types";

export const followersQueryKey = <T extends keyof SuretyEntityIdMap>(
	type: T,
	id?: SuretyEntityIdMap[T],
) => ["followers", type, id] as const;

export const followedEntitiesQueryKey = () => ["followers", "me"] as const;
